import { jsxs as l, jsx as e } from "react/jsx-runtime";
import a from "./styles.module.less.js";
const c = ({ language: r, environment: t }) => {
  const o = t === "dev" || t === "development" ? "https://portal.development.lawconnect.com" : t === "staging" ? "https://portal.staging.lawconnect.com" : "https://portal.lawconnect.com";
  return /* @__PURE__ */ l("div", { className: a.lawyerButtonsContainer, children: [
    /* @__PURE__ */ e("a", { href: o, className: a.lawyerPortalButton, children: "Lawyer portal" }),
    /* @__PURE__ */ e(
      "a",
      {
        href: `/${r}/for-lawyers/sign-up`,
        className: a.lawyerSignUpButton,
        children: "Lawyer sign up"
      }
    )
  ] });
};
export {
  c as LawyerViewButtons
};
